import { ViCodeApp } from "src/models/vicodeApp";
import { createEntityModel } from "src/store/models/entity/_shared";

export const ViCodeAppEntityModel = createEntityModel<ViCodeApp>();
